import { IUser } from '@sdk/contracts';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  HeaderWrapper,
  ItemTitle,
  ItemWrapper,
  SpinnerWrapper,
  SubscriptionsWrapper,
  Wrapper
} from './Last14DaysActivity.styles';
import { SectionList } from './SectionList';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { TagItem } from '@/components/TagItem';
import {
  useLast14DaysActivity,
  useLast14DaysQuizResults,
  useMySubscriptions,
  useStudentSubscriptions,
  useLast14DaysConnectedTime
} from '@/store';

type Props = {
  student: IUser;
};

export const Last14DaysActivity: React.FC<Props> = ({ student }) => {
  const { t } = useTranslation();
  const { subscriptions, isLoading } = useStudentSubscriptions(student._id);
  const { selectedSubscription, setSelectedSubscription } = useMySubscriptions();
  const {
    groupedBySection,
    isLoading: isLoadingActivity,
    last14DaysActivity
  } = useLast14DaysActivity(selectedSubscription?._id);
  const { last14DaysQuizResults, isLoading: isLoadingQuizResults } = useLast14DaysQuizResults(
    student._id
  );
  const { last14DaysConnectedTime, isLoadingLast14DaysConnectedTime } = useLast14DaysConnectedTime(
    student._id
  );

  useEffect(() => {
    if (subscriptions?.length && !selectedSubscription) setSelectedSubscription(subscriptions[0]);
  }, [subscriptions]);

  if (isLoading || isLoadingActivity || isLoadingQuizResults || isLoadingLast14DaysConnectedTime)
    return (
      <SpinnerWrapper>
        <LoadingCircleSpinner />
      </SpinnerWrapper>
    );

  return (
    <Wrapper>
      <SubscriptionsWrapper>
        {subscriptions?.map(subscription => (
          <TagItem
            name={subscription.course.name}
            key={subscription._id}
            progress={subscription.progress}
            isChecked={subscription._id === selectedSubscription?._id}
            onClick={() => setSelectedSubscription(subscription)}
          />
        ))}
      </SubscriptionsWrapper>
      <HeaderWrapper>
        <ItemWrapper>
          <ItemTitle>{t('NUMBER_OF_ACTIVITIES', { count: last14DaysActivity?.length })}</ItemTitle>
          <div>{t('COMPLETED_PREVIEW')}</div>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>
            {t('NUMBER_OF_HOURS', {
              count: parseFloat(((last14DaysConnectedTime ?? 0) / 60).toFixed(2))
            })}
          </ItemTitle>
          <div>{t('IN_APP')}</div>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>{t('NUMBER_OF_TESTS', { count: last14DaysQuizResults?.length })}</ItemTitle>
          <div>{t('DONE')}</div>
        </ItemWrapper>
      </HeaderWrapper>
      <ItemTitle>{t('ACTIVITIES_COMPLETED_IN_LAST_14_DAYS')}</ItemTitle>
      <SectionList sections={groupedBySection} />
    </Wrapper>
  );
};
